import cx from 'classnames';
import { ComponentProps, forwardRef } from 'react';

const SecondaryLink = forwardRef<
  HTMLAnchorElement,
  ComponentProps<'a'> & { variant?: 'default' | 'background' }
>(({ className, variant = 'default', ...props }, ref) => (
  <a
    ref={ref}
    className={cx(
      'font-bold ',
      'cursor-pointer',
      'relative',
      'py-4',
      'px-6',
      'text-sm',
      '',
      'transition-colors',
      'border',
      'border-brand-100',
      {
        'text-brand-100 hover:bg-brand-100 hover:text-white':
          variant === 'default',
        'text-white bg-brand-100 hover:bg-white hover:text-brand-100':
          variant === 'background',
      },
      className
    )}
    {...props}
  />
));

SecondaryLink.displayName = 'SecondaryLink';

export default SecondaryLink;
